import cls from 'classnames';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';

import { RoundedCheckmark, RoundedExclamation } from '../svgicons';
import { SnackbarType } from '../../../hooks/snackbar/types';

import useStyles from './styles';
import { ISnackbarProps } from './types';

const iconMap = {
  [SnackbarType.SUCCESS]: RoundedCheckmark,
  [SnackbarType.WARNING]: RoundedExclamation,
};

export default function Snackbar({
  className,
  children,
  childrenClassName,
  id,
  type,
  onClose,
}: ISnackbarProps) {
  const classes = useStyles({ type });
  const Icon = iconMap[type];

  return (
    <div className={cls(classes.root, className)}>
      <div className={classes.container}>
        <Icon className={classes.icon} />
        <div className={cls(classes.child, childrenClassName)}>{children}</div>
      </div>
      <IconCrossLarge className={classes.close} onClick={() => onClose(id)} />
    </div>
  );
}
